/**
 * @deprecated Consult with frontend chapter for better alternatives
 */
var addToPath = function addToPath(add, _ref, _ref2) {
  var pathname = _ref.pathname;
  var push = _ref2.push;
  var exist = pathname.toLowerCase().includes(add.toLowerCase());
  if (!exist) {
    var suffix = pathname === '/' ? '' : pathname;
    var prefix = pathname.slice(-1) === '/' ? '' : '/';
    var _path = "" + suffix + prefix + add;
    push(_path);
  }
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

/**
 * @deprecated Consult with frontend chapter for better alternatives
 */
var cleanPath = function cleanPath(path, prefix) {
  if (prefix === void 0) {
    prefix = '';
  }
  if (path.charAt(0) !== '/') {
    return prefix + "/" + path;
  }
  return "" + prefix + path;
};

/**
 * @deprecated Consult with frontend chapter for better alternatives
 */
var isDefaultPort = function isDefaultPort(port, protocol) {
  switch (protocol) {
    case 'http':
      return port === 80;
    case 'https':
      return port === 443;
    default:
      return false;
  }
};
var getCookie = function getCookie(name) {
  var result = typeof window === 'undefined' ? null : document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
  return result ? unescape(result[2]) : null;
};

/**
 * @deprecated Consult with frontend chapter for better alternatives
 */
var ConnectionDetails = /*#__PURE__*/function () {
  function ConnectionDetails(location) {
    this.headers = void 0;
    this.prefix = void 0;
    this.interceptor = void 0;
    this.requestInterceptor = void 0;
    this.protocol = void 0;
    this.host = void 0;
    this.port = void 0;
    var port = location.port,
      hostname = location.hostname,
      protocol = location.protocol;
    this.setProtocol(protocol);
    this.setHost(hostname);
    this.setPort(port);
    //
    this.headers = {};
    this.prefix = '';
    this.interceptor = [];
    this.requestInterceptor = [];
  }
  var _proto = ConnectionDetails.prototype;
  _proto.addHeader = function addHeader(name, value) {
    var _extends2;
    this.headers = _extends({}, this.headers, (_extends2 = {}, _extends2[name.toLowerCase()] = value, _extends2));
  };
  _proto.addResponseInterceptor = function addResponseInterceptor(interceptor) {
    // check existing
    if (this.interceptor.some(function (_ref) {
      var name = _ref.name;
      return name === interceptor.name;
    })) {
      throw new Error("ResponseInterceptor with name [" + interceptor.name + "] already exist");
    }
    this.interceptor = [].concat(this.interceptor, [interceptor]);
  };
  _proto.removeResponseInterceptor = function removeResponseInterceptor(name) {
    this.interceptor = this.interceptor.filter(function (_ref2) {
      var n = _ref2.name;
      return n !== name;
    });
  };
  _proto.addRequestInterceptor = function addRequestInterceptor(interceptor) {
    // check existing
    if (this.requestInterceptor.some(function (_ref3) {
      var name = _ref3.name;
      return name === interceptor.name;
    })) {
      throw new Error("RequestInterceptor with name [" + interceptor.name + "] already exist");
    }
    this.requestInterceptor = [].concat(this.requestInterceptor, [interceptor]);
  };
  _proto.removeRequestInterceptor = function removeRequestInterceptor(name) {
    this.requestInterceptor = this.requestInterceptor.filter(function (_ref4) {
      var n = _ref4.name;
      return n !== name;
    });
  };
  _proto.removeHeader = function removeHeader(name) {
    var _this$headers = this.headers;
      _this$headers[name];
      var newHeader = _objectWithoutPropertiesLoose(_this$headers, [name].map(_toPropertyKey));
    this.headers = newHeader;
  };
  _proto.setPrefix = function setPrefix(prefix) {
    this.prefix = prefix;
  };
  _proto.setProtocol = function setProtocol(protocol) {
    this.protocol = protocol.replace(':', '');
  };
  _proto.setHost = function setHost(host) {
    this.host = host;
  };
  _proto.setPort = function setPort(port) {
    this.port = port;
  };
  _proto.build = function build(path) {
    var port = this.port,
      host = this.host,
      prefix = this.prefix,
      protocol = this.protocol;
    return protocol + "://" + host + (isDefaultPort(port, protocol) ? '' : ":" + port) + cleanPath(path, prefix);
  };
  _proto.appendHeader = function appendHeader(options) {
    var xsrfToken = getCookie('XSRF-TOKEN');

    // eslint-disable-next-line no-eq-null, eqeqeq
    if (xsrfToken != null) {
      this.addHeader('X-XSRF-TOKEN', xsrfToken);
    }
    if (Object.keys(this.headers).length === 0) {
      return options;
    }
    return _extends({}, options, {
      headers: _extends({}, this.headers, options.headers)
    });
  };
  _proto.appendInterceptor = function appendInterceptor(res, interceptorConfig) {
    // eslint-disable-next-line array-callback-return
    this.interceptor.forEach(function (_ref5) {
      var name = _ref5.name,
        func = _ref5.func;
      return func(res, interceptorConfig[name]);
    });
    //
    return Promise.resolve(res);
  };
  _proto.appendRequestInterceptor = function appendRequestInterceptor() {
    var proms = this.requestInterceptor.map(function (_ref6) {
      var func = _ref6.func;
      return func();
    });
    return Promise.all(proms);
  };
  return ConnectionDetails;
}();
var connections = {
  "default": typeof window === 'undefined' ? null : new ConnectionDetails(window.location)
};

/**
 * @deprecated Consult with frontend chapter for better alternatives
 */
var getConnection = function getConnection(scope) {
  if (scope === void 0) {
    scope = 'default';
  }
  if (!connections[scope] && typeof window !== 'undefined') {
    connections[scope] = new ConnectionDetails(window.location);
  }
  return connections[scope];
};
//
/**
 * @deprecated Consult with frontend chapter for better alternatives
 */
var getContextPath = function getContextPath() {
  return typeof window !== 'undefined' && window.publicPath || '/home';
};
var fetchWrapper = function fetchWrapper(conn, path, options, interceptorConfig) {
  if (options === void 0) {
    options = {};
  }
  if (interceptorConfig === void 0) {
    interceptorConfig = {};
  }
  return conn.appendRequestInterceptor().then(function () {
    return fetch(conn.build(path), conn.appendHeader(_extends({
      credentials: 'same-origin'
    }, options)));
  }).then(function (res) {
    return conn.appendInterceptor(res, interceptorConfig);
  });
};

export { addToPath, fetchWrapper as default, getConnection, getContextPath };
//# sourceMappingURL=index.js.map
